class SessionExpiredService {
  private model = {
    show: false,
    color: "",
    text: "",
    timeout: 4000,
    timeRemaining: 0
  };

  getModel() {
    return this.model;
  }

  show(timeRemaining: number, timeout = 4000) {
    console.log("SessionExpiredService: show called with timeRemaining:", timeRemaining);
    this.model.timeRemaining = timeRemaining;
    this.model.show = true;
    this.model.timeout = timeout;
  }

  hide() {
    this.model.show = false;
  }
}

export default new SessionExpiredService();
